import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("cc_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("cc_token");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const setToken = (t) => localStorage.setItem("cc_token", t);
export const clearToken = () => localStorage.removeItem("cc_token");
export const getToken = () => localStorage.getItem("cc_token");

// Presence heartbeat — pings /auth/heartbeat every 30s so admins can see
// who is live on the app right now. Call once at the app shell level.
import { useEffect } from "react";
export function useHeartbeat(intervalMs = 30000) {
  useEffect(() => {
    if (!getToken()) return;
    let stopped = false;
    const ping = () => { if (!stopped) api.post("/auth/heartbeat").catch(() => {}); };
    ping();
    const t = setInterval(ping, intervalMs);
    return () => { stopped = true; clearInterval(t); };
  }, [intervalMs]);
}
